import moment from 'moment';

export function parseDate(value) {
    if (!value) {
        return { startDate: null, endDate: null };
    }
    const dates = value.split('-');
    const startDate = moment(dates[0], 'DD/MM/YYYY');
    const endDate = dates[1] ? moment(dates[1], 'DD/MM/YYYY') : null;

    return { startDate, endDate };
}
export function formatDate(startDate, endDate, format = 'DD/MM/YYYY') {
    if (startDate && endDate) {
        return `${moment(startDate).format(format)} - ${moment(endDate).format(
            format
        )}`;
    }
    if (startDate && !endDate) {
        return moment(startDate).format(format);
    }
    return '';
}

export function formatFilterData(
    startDate,
    endDate,
    startField = 'dateCreated',
    endField = null
) {
    // props: startDate (string), endDate (string), startField (string), endField (string|null)

    const field = startField;
    const effectiveEndField = endField || startField;

    const filterData = [];
    const format = 'YYYY-MM-DDTHH:mm:ss.SSSSSS';

    if (startDate && endDate) {
        filterData.push({
            field: field,
            op: '>',
            value: moment(startDate, 'DD/MM/YYYY').startOf('day').format(format)
        });
        filterData.push({
            field: effectiveEndField,
            op: '<',
            value: moment(endDate, 'DD/MM/YYYY').endOf('day').format(format)
        });
    }
    if (startDate && !endDate) {
        filterData.push({
            field: field,
            op: '>',
            value: moment(startDate, 'DD/MM/YYYY').startOf('day').format(format)
        });
        filterData.push({
            field: effectiveEndField,
            op: '<',
            value: moment(startDate, 'DD/MM/YYYY').endOf('day').format(format)
        });
    }
    return filterData;

}
